import { DiscoverAppsPage } from "./DiscoverAppsPage";

export function CategoriesPage() {
  return <DiscoverAppsPage mode="categories" />;
}
